var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 16.3332C13.166 15.2281 13.605 14.1683 14.3864 13.3869C15.1678 12.6055 16.2276 12.1665 17.3327 12.1665H25.666C26.7711 12.1665 27.8309 12.6055 28.6123 13.3869C29.3937 14.1683 29.8327 15.2281 29.8327 16.3332V24.6665C29.8327 25.7716 29.3937 26.8314 28.6123 27.6128C27.8309 28.3942 26.7711 28.8332 25.666 28.8332H17.3327C16.2276 28.8332 15.1678 28.3942 14.3864 27.6128C13.605 26.8314 13.166 25.7716 13.166 24.6665V16.3332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 15.8125V15.8229M18.375 20.5C18.375 21.3288 18.7042 22.1237 19.2903 22.7097C19.8763 23.2958 20.6712 23.625 21.5 23.625C22.3288 23.625 23.1237 23.2958 23.7097 22.7097C24.2958 22.1237 24.625 21.3288 24.625 20.5C24.625 19.6712 24.2958 18.8763 23.7097 18.2903C23.1237 17.7042 22.3288 17.375 21.5 17.375C20.6712 17.375 19.8763 17.7042 19.2903 18.2903C18.7042 18.8763 18.375 19.6712 18.375 20.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.f613f73aa1e77817db65a4c5f7b7bfc5.svg";
export { ForwardRef as ReactComponent };